import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSphere = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.4905 4.37646C2.25917 3.87496 2.48642 3.29987 2.99808 3.09197L6.70383 1.58618C7.21549 1.37828 7.8178 1.61628 8.04913 2.11779L8.90325 3.96942C9.09322 3.95096 9.28665 3.98707 9.45972 4.07666L11.2435 5.00004H18C18.3183 5.00004 18.6175 5.15152 18.8059 5.40801L20.8059 8.13055C20.932 8.30219 21 8.5096 21 8.72258V15.1546C21 15.2676 20.9809 15.3797 20.9434 15.4862L20 18.1706V21C20 21.5523 19.5523 22 19 22H7.00001C6.44773 22 6.00001 21.5523 6.00001 21V18.1231L5.09705 14.5113L3.2929 12.7071C3.10537 12.5196 3.00001 12.2653 3.00001 12V7.00003C3.00001 6.7025 3.13183 6.42665 3.3501 6.23996L2.4905 4.37646ZM6.61512 3.77873L7.03343 4.68557L5.18107 5.43959L4.76224 4.53162L6.61512 3.77873ZM8.00001 19V20H18V19H8.00001ZM18.2915 17L19 14.984V9.05041L17.4938 7.00004H16.75V17H18.2915ZM15.25 17V7.00004H11.75V17H15.25ZM10.25 17H7.78079L6.97016 13.7575C6.9262 13.5817 6.83528 13.4211 6.70712 13.2929L5.00001 11.5858V7.67265L8.94987 6.06482L10.25 6.73784V17Z",
		fill: "#646060"
	})
});
export default SvgSphere;
